import { useState, useEffect } from 'react';
import { propertyService } from '../services/propertyService.ts';
import { Property, PropertyFormData } from '../types/property';

export const useProperties = () => {
  const [properties, setProperties] = useState<Property[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    fetchProperties();
  }, []);

  const fetchProperties = async () => {
    try {
      setLoading(true);
      const data = await propertyService.fetchProperties();
      setProperties(data);
      setError(null);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  };

  const addProperty = async (propertyData: PropertyFormData) => {
    try {
      const newProperty = await propertyService.createProperty(propertyData);
      setProperties([newProperty, ...properties]);
      return newProperty;
    } catch (err) {
      throw err;
    }
  };

  const updateProperty = async (id: string, propertyData: PropertyFormData) => {
    try {
      const updatedProperty = await propertyService.updateProperty(id, propertyData);
      setProperties(properties.map(p => p.id === id ? updatedProperty : p));
      return updatedProperty;
    } catch (err) {
      throw err;
    }
  };

  const deleteProperty = async (id: string) => {
    try {
      await propertyService.deleteProperty(id);
      setProperties(properties.filter(p => p.id !== id));
    } catch (err) {
      throw err;
    }
  };

  return {
    properties,
    loading,
    error,
    addProperty,
    updateProperty,
    deleteProperty,
    refresh: fetchProperties,
  };
};
